import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import Image from '../components/clickableImages/Image';

let imageCount = 0;

class ImageList extends Component {
  componentDidMount() {
    const { images, updateModalImages } = this.props;
    updateModalImages(images);
  }
  render() {
    const { images, title, updateModalImage } = this.props;
    return (
      <div className="content__image-list">
        {
          images.map((image) => {
            imageCount += 1;
            const key1stPart = title.replace(/\s/g, '');
            return (
              <Image
                alt={title}
                key={`${key1stPart}-${imageCount}`}
                {...image}
                onClick={() => {
                  updateModalImage({
                    url: image.image,
                    alt: title,
                    caption: image.caption,
                  });
                }}
              />
            );
          })
        }
      </div>
    );
  }
}

ImageList.propTypes = {
  images: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string.isRequired,
  updateModalImage: PropTypes.func,
  updateModalImages: PropTypes.func.isRequired,
};

ImageList.defaultProps = {
  updateModalImage: undefined,
};

ImageList = connect( //eslint-disable-line
  null,
  actions,
)(ImageList);


export default ImageList;



// WEBPACK FOOTER //
// ./js/containers/ImageList.js